
var FAVORITE_USEROPTION_ITEMSPERLINE = 0;
var FAVORITE_USEROPTION_DEFAULTLIST = 1;

function FavoriteList() {
    /// <summary>
    /// This object provides js functions for the Widget.Favorites.List.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 19.1.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 22.3.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.userOptions = new vcUserOptions();
    this.day = "";
    this.minItemWidth = 350;
    this.defaultItemsPerLine = 4;
    this.mobileMaxItemWidth = 1530;
    this.isPlaylist = false;
    this.isMyOwn = false;
    this.userFavId = -1;
    // the width of the visual in an entry itself!!
    this.singleVisualWidth = 0;
    // the height of the visual in an entry itself!! - not the height of the full entry!!!
    this.singleVisualHeight = 0;
    // the height of the complete entry!
    this.fullEntryHeight = 0;
    this.resolutionFactor = 1.7778;
    this.fullscreenPopupWidth = 900;
    this.fullscreenPopupHeight = 506;
    this.bInitCal = false;
}

FavoriteList.prototype = new vcTemplate();

FavoriteList.prototype.init = function() {
    /// <summary>
    /// This function fetches existing user options and prepares the initial settings.
    /// </summary>
    var me = this;
    try {
        me.fullscreenPopupWidth = parseInt(me.width * 0.95);
        me.fullscreenPopupHeight = parseInt($(window).height() * 0.75);

        me.userOptions.getUserOptions({ 'optgroupid': 'favorites' }, function(result) {

            if (result === null) {
                me.start();
                return true;
            }
            if (result.rows === null) {
                alert(me.resources.err_loadData);
                return false;
            }

            for (var i = 0; i < result.rows.length; i++) {
                //get the stored slider value
                if (result.rows[i].optid === FAVORITE_USEROPTION_ITEMSPERLINE) {
                    me.defaultItemsPerLine = parseInt(result.rows[i].dval, 10);
                }
                //get the stored favorite list
                if (result.rows[i].optid === FAVORITE_USEROPTION_DEFAULTLIST) {
                    me.userFavId = parseInt(result.rows[i].dval, 10);
                    if (me.visual.find("#ddlList option[value='" + me.userFavId + "']").val() !== undefined) {
                        me.visual.find("#ddlList").val(me.userFavId);
                    }
                }
            }
            me.start();
            return true;
        });
        return true;
    } catch (ex) {me.writeError('init', ex);return false;
    }

};

FavoriteList.prototype.start = function() {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
 
    try {
        if (me.error) {
            return false;
        }
      
        me.showInfo("", "", false);

        //set the current item widths
        me.initSlider();
        me.setSize();


        //add the click handler for the favorite list editing (top menu)
        me.visual.find("#divBtnAddList,#divBtnEditList,#divBtnDelList").button();
        me.visual.find("#divList").off('click', "#divBtnAddList").on('click', "#divBtnAddList", function() { me.toggleFavoriteList(true); });
        me.visual.find("#divList").off('click', "#divBtnEditList").on('click', "#divBtnEditList", function() { me.toggleFavoriteList(false); });
        me.visual.find("#divFavDetailsDel").off('click', "#divBtnDelList").on('click', "#divBtnDelList", function() {me.delFavoriteList(); });

        //init the change handler for the favorite list dropdown
        me.visual.find("#divList").off('change', "#ddlList").on('change', "#ddlList", function () {
            me.userFavId = parseInt(me.visual.find("#ddlList").val(), 10);
            //save the current selection to the user options
            me.userOptions.setUserOptions({ 'optgroupid': 'favorites', 'optid': FAVORITE_USEROPTION_DEFAULTLIST, 'dval': me.userFavId }, function () { });
            me.load();
        });
        //init the edit button for the entry captions and playlist settings
        me.visual.find("#divBtnEdit").off("click").on("click", function() { me.toggleEdit($(this)); });

        //init the section button
        me.visual.find('#divBtnMenu').off('click').on('click', function() { me.toggleMenu(this); });
        //init the submenu buttons in the selection menu
        me.visual.find('.btnFavMenu').button().off('click').on('click', function () { me.fillMenu(this); });
        //clickhandler for the currency icon
        me.visual.find("#divCurrency").off("click").on("click", function() { me.toggleCurrency($(this)); });
        //change handler for the signal selection in the sub menu
        me.visual.find("#ddlSignal").off('change').on('change', function () { me.loadTemplates(true); });
        //inits the add-button
        me.visual.find("#chartList").off('click', '.add').on('click', '.add', function() { me.add(this); });

        //inits the entry icons (top right)
        me.visual.find("#entryList").off('click', '.del').on('click', '.del', function() { me.askDel(this); });
        me.visual.find("#entryList").off('keyup', 'input.edit').on('keyup', 'input.edit', function() { me.validate(this); });
        me.visual.find("#entryList").off('click', '.save').on('click', '.save', function() { me.save(this); });

        //init the fullscreen modal dialog and click handler
        me.initFullscreenDialog();
        me.visual.find("#entryList").off('click', '.fullscreen').on('click', '.fullscreen', function() { me.goFullscreen(this); });

        //init the vcDate
        me.visual.find("#div-date-box").vcDate({
            mode: "Single", align: "left", interval: 1, langID: me.userLangidForCulture, callback: function(obj) {
            if (me.bInitCal) {
                me.setDate(obj);
            }
            me.bInitCal = true;
        } });


        me.visual.find("#divList").show();
        //make the list sortable 
        me.setSortable();
        //load the list
        me.load();
        return true;
    } catch (ex) {
        me.writeError('start', ex);
        return false;
    }

};



FavoriteList.prototype.setDate = function (obj) {
    /// <summary>
    /// This function sets changed dates and reloads the list. 
    /// </summary>
    var me = this;

    try {
        if (me.error) { return false;}
        //me.visual.find('.txtDate').val(me.visual.find('.txtDateShow').val());
        //me.day = me.visual.find('.txtDate').val();

        me.day = obj.returnDates.from;

        me.fillMenu(me.visual.find(".btnFavMenu.button-toggle-active"));
        me.load();
        return true;
    } catch (ex) {
        me.writeError('setDate', ex);
        return false;
    }

};

FavoriteList.prototype.initSlider = function() {
    /// <summary>
    /// This function inits the entry size slider and calculates the possible item numbers based on the screen resolution.
    /// </summary>
    var me = this;
    var maxItems, val;
    try {
        if (me.error) {
            return false;
        }
        maxItems = parseInt((me.width / me.minItemWidth), 10);
        if (maxItems > 5) {
            maxItems = 5;
        }
        if (me.mobile) {
            //hardcoded adjusted width to home/cockpit sizes 
            if (me.width > me.mobileMaxItemWidth) {
                maxItems = 2;
            } else {
                maxItems = 1;
            }
        }
        if (maxItems === 5) {
            val = 4;
        } else {
            val = maxItems;
        }

        if ((me.defaultItemsPerLine > 0) && (me.defaultItemsPerLine <= maxItems)) { val = me.defaultItemsPerLine;}

        me.visual.find("#divSlider").slider({value: val,min: 1,max: maxItems,step: 1,
            stop: function(event, ui) {
                me.userOptions.setUserOptions({ 'optgroupid': 'favorites', 'optid': FAVORITE_USEROPTION_ITEMSPERLINE, 'dval': ui.value }, function () { });
                me.setSize();
                me.load();
            }
        });

        return true;
    } catch (ex) {
        me.writeError('initSlider', ex);
        return false;
    }

};

FavoriteList.prototype.setSize = function() {
    /// <summary>
    /// This function calculates the available items per line based on the screen resolution and slider value. <br/>
    /// It fixes the width and height of each single visual!<br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        var margin = 0;
        var itemsPerLine = parseInt(me.visual.find("#divSlider").slider("value"), 10);

        //adopt widths
        if (itemsPerLine <= 2) {margin = 35;}
        if (itemsPerLine > 2) {margin = 28;}
        //set the width and height of the visuals!!
        me.singleVisualWidth = parseInt(me.width / itemsPerLine, 10) - margin;
        me.singleVisualHeight = parseInt(me.singleVisualWidth / me.resolutionFactor, 10);


        return true;
    } catch (ex) {
        me.writeError('setSize', ex);
        return false;
    }
};

FavoriteList.prototype.adjustSize = function() {
    /// <summary>
    /// This function resets the new width and height of the entries and the placeholder of the sortable list. 
    /// </summary>
    var me = this;
    var h,w;
    try {
        if (me.error) { return false; }
        //get the height of the entry header
        h = parseInt(me.visual.find("#entryList .favItem .favItemHeader").height(), 10);

        if (isNaN(h)) {h = 0;}
        h = me.singleVisualHeight + h + 20;
        if (me.isPlaylist) { h += 28; }

        me.fullEntryHeight = h;

        if (me.mobile === false) {
            w = me.singleVisualWidth;
        } else {
            w = me.visual.find("#divEntries").width() ;
        }

        me.visual.find("#entryList .favItem").width(w).height(h);
        me.visual.find("#entryList .favPlaceholder").width(w).height(h);
        if (me.mobile === false) {
            w -= 110;
        } else {
            w -= 10;
        }
        me.visual.find("#entryList .favItem .favItemHeader").width(w);

        me.adoptListHeight();

       

        return true;
    } catch (ex) {
        me.writeError('adjustSize', ex);
        return false;
    }
};


FavoriteList.prototype.adoptListHeight = function () {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    var h, bh;
    try {
        if (me.mobile === false) {
            h = parseInt(me.visual.find("#entryList").height());
            bh = parseInt(_iBrowserHeight) -
                parseInt($("#header").height() + $("#divMasterBack").height() + me.visual.find("#divWrapper").height());
            if (h > bh) {
                me.visual.find("#entryList").height(bh - 40).css("overflow-y", "auto").css("width", "101%");
            }

            me.visual.find("#divMenu").height(bh - 60);
            me.visual.find("#chartListFrame").height(bh - 145);
        } else {
            me.visual.find("#entryList").css("overflow-y", "auto").css("width", "101%");
        }

    } catch (ex) { me.writeError('adoptListHeight', ex); }
};

FavoriteList.prototype.toggleMenu = function() {
    /// <summary>
    ///  This function shows/hides the selection menu. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        if (me.visual.find("#divMenu").is(":visible")) {
            me.visual.find("#divBtnMenu").removeClass("button-toggle-active");
            me.visual.find("#divMenu").hide();
            me.visual.find("#divEntries").css("width", "100%").removeClass("openMenu");
        } else {
            me.visual.find("#divBtnMenu").addClass("button-toggle-active");
            me.visual.find("#divMenu").show();
            me.visual.find("#divEntries").width(me.visual.find("#divEntries").outerWidth() - me.visual.find("#divMenu").outerWidth() - 20).addClass("openMenu");
            me.fillMenu(me.visual.find('#divBtnShowChartMenu'));
        }

        me.adoptListHeight();
        return true;
    } catch (ex) {
        me.writeError('toggleMenu', ex);
        return false;
    }

};

FavoriteList.prototype.fillMenu = function(obj) {
    /// <summary>
    /// This function takes the visual type menu id from the menu button and loads the template charts.
    /// </summary>
    var me = this;
    var bContainsSignals;
    try {
        if (me.error) {return false; }

        if (me.visual.find("#divMenu").is(":visible") === false) {
            me.visual.find("#chartList").html("");
            return true;
        }
        //get the menu type id
        me.menuTypeId = parseInt($(obj).attr("data-menuTypeId"), 10);
        bContainsSignals = $(obj).attr("data-containsSignals") === "true" ? true : false;
        //some show/hiding
        me.visual.find(".btnFavMenu").removeClass("button-toggle-active");
        $(obj).addClass("button-toggle-active");
        me.visual.find("#divMenuContent").fadeIn();
        if (bContainsSignals) {
            me.visual.find("#divDdlSignal").show();
            if (me.visual.find("#ddlSignal").hasClass("chzn-done") === false) {
                me.visual.find("#ddlSignal").chosen();
            }

        } else {
            me.visual.find("#divDdlSignal").hide();
        }
        //get the new templates
        me.loadTemplates(bContainsSignals);

        return true;
    } catch (ex) {me.writeError('fillMenu', ex);return false;
    }

};

FavoriteList.prototype.toggleCurrency = function (obj) {
    /// <summary>
    /// This function switches between energy consumptions and euros. It reloads the currently selected menu item.  
    /// </summary>
    var me = this;
    try {
        obj.toggleClass("button-toggle-active");
        me.fillMenu(me.visual.find(".btnFavMenu.button-toggle-active"));
        return true;
    } catch (ex) { me.writeError('toggleCurrency', ex); return false; }
};

FavoriteList.prototype.loadTemplates = function(bContainsSignals) {
    /// <summary>
    /// This function loads the template visuals to the selection menu based on the selected menu type. 
    /// </summary>
    var me = this;
    var bsaid;
    var bUsePrices;
    try {
        if (me.error) { return false; }

        //get the selected signal id 
        if (bContainsSignals) {
            bsaid = parseInt(me.visual.find("#ddlSignal").val(), 10);
            if (isNaN(bsaid)) {
                me.showMessage(me.resources.noEntriesExist, true);
                return true;
            }
        } else {
            bsaid = -1;
        }
        //check if prices are on
        bUsePrices = me.visual.find("#divCurrency").hasClass("button-toggle-active");
        //load the entries
        me.visual.find("#chartList").html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, me.day, 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 2, 'collid': me.collid, 'TemplateBsaid': bsaid, 'Height': me.singleVisualHeight, 'Width': me.singleVisualWidth, 'menuTypeId': me.menuTypeId, 'UsePrices': bUsePrices }),
            function(result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                if (result === "") {
                    me.visual.find("#chartList").html("<div class='note'>" + me.resources.noEntriesExist + "</div>");
                    return false;
                }
                me.visual.find("#chartList").hide(0).html(result);
                me.visual.find("#chartList .favItem").has("[class*='ui-state-error']").hide(0);
                me.visual.find("#chartList").show();
                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('loadTemplates', ex);
        return false;
    }

};

FavoriteList.prototype.toggleEdit = function (obj) {
    /// <summary>
    /// This function makes the entry caption and playlists settings editable.<br/>
    /// If editing is on a save-button for each entry is shown. <br/>
    /// If any entry is dirty (not saved) a dialog box asks if the changes should get dismissed. 
    /// </summary>
    var me = this;
    try {

        if (obj.hasClass("button-toggle-active") === false) {
            me.visual.find("#entryList .favItem .favInput").prop("readonly", false).addClass("edit");
            me.visual.find("#entryList .favItem .favItemHeaderIcons").hide();
            me.visual.find("#entryList .favItem .save").show(); 
            obj.toggleClass("button-toggle-active");
            } else {
            if (me.visual.find("#entryList .favItem .favInput.dirty").length > 0) {

                    var dialog = $('<p>' + me.resources.dismissChanges + '</p>').dialog({
                        title: me.resources.dialogTitle,
                        modal: true, 
                        buttons: {
                            "Yes": function () {
                                obj.toggleClass("button-toggle-active");
                                me.visual.find("#entryList .favItem .favInput").prop("readonly", true).removeClass("edit dirty invalid");
                                me.visual.find("#entryList .favItem  .save").hide();
                                me.visual.find("#entryList .favItem .favItemHeaderIcons").show();
                                dialog.dialog('close');
                            },
                            "Cancel": function() {
                                dialog.dialog('close');
                                return false;
                            }
                        },
                        dialogClass: 'saveDialog'
                    });
                    // ReSharper disable InvalidValue
                    $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
                    $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
                    // ReSharper restore InvalidValue

                } else {
                    me.visual.find("#entryList .favItem .favInput").prop("readonly", true).removeClass("edit");
                    me.visual.find("#entryList .favItem .save").hide();
                    me.visual.find("#entryList .favItem .favItemHeaderIcons").show();
                    obj.toggleClass("button-toggle-active");
                }        
        }

        return true;
    } catch (ex) { me.writeError('toggleEdit', ex); return false; }
};

FavoriteList.prototype.load = function () {
    /// <summary>
    ///  This function fills the sortable list with entries from the selected favorite list. 
    /// </summary>
    var me = this;
    var w;
    try {
        if (me.error) { return false; }

        me.showInfo("", "", false);
        // get the collection id
        me.collid = parseInt(me.visual.find("#ddlList").val(), 10);
        if (me.mobile === false) {
            w = me.singleVisualWidth;
            me.isPlaylist = me.visual.find("#ddlList option[value='" + me.collid + "']").attr("data-isplaylist") === "true" ? true : false;
        } else {
            w = me.visual.find("#divEntries").width() -2;
         
            me.isPlaylist = false;
        }
        me.isMyOwn = me.visual.find("#ddlList option[value='" + me.collid + "']").attr("data-isMyOwn") === "true" ? true : false;
        if (me.isMyOwn) {
            me.visual.find("#divBtnEditList").button('enable');
        } else {
            me.visual.find("#divBtnEditList").button('disable');
        }



        me.visual.find("#entryList").html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, me.day, 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 1, 'collid': me.collid, 'Height': me.singleVisualHeight, 'Width': w, 'isPlaylist': me.isPlaylist }),
            function (result) {
                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
               
                if (result === "") {
                    me.showMessage(me.resources.emptyFavoriteList, false);
                    me.visual.find("#entryList").html("");
                    return true;
                }
                me.visual.find("#entryList").hide().html(result);
                me.adjustSize();

               
                me.visual.find("#entryList").show();
                return true;
            },
            function() {
                me.visual.find("#entryList").html("<div class='note'>" + me.resources.favoritelistTooLargeToshow + "</div>").show();
            });


        return true;
    } catch (ex) {
        me.writeError('load', ex);
        return false;
    }
};

FavoriteList.prototype.askDel = function (obj) {
    /// <summary>
    /// This function implements an dialog box for deleting entries. 
    /// </summary>
    var me = this;
    try {
       
        var dialog = $('<p>' + me.resources.shouldEntryBeDeleted + '</p>').dialog({
            title: me.resources.dialogTitle,
            modal: true, 
            dialogClass: 'saveDialog',
            buttons: {
                "Yes": function () {
                    me.del(obj);
                    dialog.dialog('close');
                    return true;
                },
                "Cancel": function () {
                    dialog.dialog('close');
                    return false;
                }
            }
        });
        // ReSharper disable InvalidValue
        $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
        $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        // ReSharper restore InvalidValue

        return true;
    } catch (ex) { me.writeError('askDel', ex); return false; }
};

FavoriteList.prototype.del = function(obj) {
    /// <summary>
    /// This function takes an entry id, hides the entry, sends the id to the server for deleting and updates the sorting.
    /// </summary>
    var me = this;
    var id;
    try {
        if (me.error) {return false;}

        id = parseInt($(obj).attr("data-id"), 10);
        me.visual.find(".favItem[data-id=" + id + "]").fadeOut().remove();
      
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, me.day, 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 3, 'collid': me.collid, 'collentryid': id }),
            function (result) {
                if (result !== true) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
        
                me.updateSorting();
                me.showStatus(me.resources.chartGotDeleted);
                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('del', ex);
        return false;
    }

};

FavoriteList.prototype.add = function(obj) {
    /// <summary>
    /// This function takes the template values and settings sends them to the server and adds the returned new visual to the entry list. 
    /// </summary>
    var me = this;
    var id;
    var bsaid, name, description, bUsePrices;
    try {
        if (me.error) { return false;}

        // get the id, name, description and signal id from the template
        id = $(obj).attr("data-id");

        name = me.visual.find("input.name[data-id=" + id + "]").val();
        if (name.length === 0) {
            alert(me.resources.emptyField);
            return false;
        }
        description = me.visual.find("input.description[data-id=" + id + "]").val();

        id = parseInt(id.replace("tpl", ""), 10);

        bsaid = parseInt(me.visual.find("#ddlSignal").val(), 10);
        bUsePrices = me.visual.find("#divCurrency").hasClass("button-toggle-active");
        //send it to the server
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, me.day, 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 2, 'collid': me.collid, 'CollEntryId': id, 'TemplateBsaid': bsaid, 'Height': me.singleVisualHeight, 'Width': me.singleVisualWidth, 'name': name, 'description': description, 'UsePrices': bUsePrices, 'menuTypeId': me.menuTypeId, 'isPlaylist': me.isPlaylist }),
            function(result) {
                if (result === null || result === "") {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                //add the return visual
                me.visual.find("#entryList").append(result);
                me.adjustSize();
                me.updateSorting();
                me.showInfo("", "", false);
                me.visual.find("input[data-id=tpl" + id + "]").removeClass("dirty invalid");
                me.showStatus(me.resources.chartGotAdded);
                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('add', ex);
        return false;
    }

};

FavoriteList.prototype.save = function(obj) {
    /// <summary>
    /// This function saves one single entry.
    /// </summary>
    var me = this;
    var id;
    var name, description;
    var duration, startDate, endDate;
    try {
        if (me.error) {return false;}
        //do nothing of button is not active
        if ($(obj).hasClass("active") === false) {return false;}

        id = $(obj).attr("data-id");
        //get all captions and settings
        name = me.visual.find("input.name[data-id=" + id + "]").val();
        description = me.visual.find("input.description[data-id=" + id + "]").val();
        duration = me.visual.find("input.duration[data-id=" + id + "]").val();
        startDate = me.visual.find("input.startdate[data-id=" + id + "]").val();
        endDate = me.visual.find("input.enddate[data-id=" + id + "]").val();

        if (name.length === 0 || duration.length === 0) {
            alert(me.resources.emptyField);
            return false;
        }
        duration = parseInt(duration, 10);
        //ave everything
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, me.day, 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 5, 'CollEntryId': id, 'name': name, 'description': description, 'duration': duration, 'startDate': startDate, 'endDate': endDate }),
            function(result) {
                if (result !== true) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.visual.find("input[data-id=" + id + "]").removeClass("dirty invalid");
                $(obj).removeClass("active");
                me.showStatus(me.resources.chartGotsaved);
                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('save', ex);
        return false;
    }

};

FavoriteList.prototype.validate = function (obj) {
    /// <summary>
    /// This function validates the edited captions and playlist settings of one single entry.<br/>
    /// If any value got edited it adds a 'dirty' class - if anything is invalid an 'invalid' class
    /// </summary>
    var me = this;
    var bValid = true;
    try {
        var id = parseInt($(obj).attr("data-id"), 10);
        $(obj).addClass("dirty");

        if ($(obj).hasClass("name") || $(obj).hasClass("duration")) {
            if ($(obj).val().length > 0) {
                if ($(obj).hasClass("duration")) {
                    if (isNaN(parseInt($(obj).val(), 10))) {
                        bValid = false;
                    }
                }
            } else {
                bValid = false;
            }
        } else {
            if ($(obj).hasClass("date")) {
                if ($(obj).val().length > 0) {
                    if (isDate($(obj).val()) === false) { bValid = false; }
                }
            }
        }

        if (bValid) {
            $(obj).removeClass("invalid");
        } else {
            $(obj).addClass("invalid");
        }

        if (me.visual.find("input[data-id=" + id + "].dirty").length > 0) {
            if (me.visual.find("input[data-id=" + id + "].invalid").length > 0) {
                me.visual.find(".save[data-id=" + id + "]").removeClass("active");
            } else {
                me.visual.find(".save[data-id=" + id + "]").addClass("active");
            }
        }

        return true;
    } catch (ex) { writeError('validate', ex); return false; }
};

FavoriteList.prototype.setSortable = function() {
    /// <summary>
    /// Inits the list as sortable list - items can get sorted by drag and drop.<br/>
    /// After each drag the sorting gets updated.
    /// </summary>
    var me = this;
    try {
        if (me.error) {return false;}
        if (me.mobile) { return true;}

        me.visual.find("#entryList").sortable({
            cancel: "input.edit, textarea.edit", tolerance: 'pointer',cursor: 'move',placeholder: "favPlaceholder",
            update: function() {
                me.updateSorting();
                me.showStatus(me.resources.listGotSorted);
            },
            start: function (e, ui) {
                //set the current width and height of the entries for the placeholder
                ui.placeholder.height(me.fullEntryHeight);
                ui.placeholder.width(me.singleVisualWidth);
            }
        });
        return true;
    } catch (ex) { me.writeError('setSortable', ex);return false;}

};

FavoriteList.prototype.updateSorting = function () {
    /// <summary>
    /// This function iterates all entries, get's their ids and sends the sorted list to the server for updating the sorting.
    /// </summary>
    var me = this;
    var idList = [];
    try {
        if (me.error) {return false;}

        me.visual.find("#entryList li").each(function () {
            //sort visible items only
            if ($(this).is(":visible")) {idList.push($(this).attr("data-id"));}
        });

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, me.day, 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 1, 'collid': me.collid, 'IdList': idList }),
            function (result) {
                if (result !== true) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('updateSorting', ex);
        return false;
    }

};

FavoriteList.prototype.toggleFavoriteList = function (bNew) {
    /// <summary>
    /// This function shows/hides the edit vcForm for the favorite lists themselves. 
    /// </summary>
    var me = this;
    var collid;
    try {
        if (me.error) { return false; }

        if (me.visual.find("#divFavDetails").is(":visible")) {
            me.visual.find("#divFormFavList").html("");
            me.visual.find("#divFavDetails").hide();

            me.visual.find("#divList").html(me.vcC.getLoadingIcon());
            window.VisualCoreService.getData(me.vcvid, me.vcgid, me.day, 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 3 }),
                function (result) {
                    me.visual.find("#divMain, .divCalendar, #divBtnMenu, #divSliderFrame,#divBtnEdit, #divRightMenu, #divMenuBreakline").show();
                    if (result === null) {
                        me.showMessage(me.resources.err_loadData, true);
                        return false;
                    }
                    me.visual.find("#divList").html(result).show();
                    me.visual.find("#divBtnAddList,#divBtnEditList").button();

                    if (me.visual.find("#ddlList option[value='" + me.userFavId + "']").val() !== undefined) {
                        me.visual.find("#ddlList").val(me.userFavId);
                    }
                    me.load();

                    return true;
                });

        } else {
            if (bNew) {
                collid = -1;
                me.visual.find("#divFavDetailsDel, #divFavUserAssignment").hide();
            } else {
                me.visual.find("#divFavDetailNoDel").hide();
                me.visual.find("#divFavUserAssignment").show();
                collid = me.collid;
                if (me.visual.find("#ddlList option").length < 2) {
                    me.visual.find("#divFavDetailsDel").hide();
                } else {
                    me.visual.find("#divFavDetailsDel").show();
                }
            }
            me.visual.find("#divList, #divMain, .divCalendar, #divBtnMenu, #divSliderFrame,#divBtnEdit, #divRightMenu, #divMenuBreakline").hide();
            me.visual.find("#divFavDetails").show();
            me.vcVisual.addVisualBaseByName("divForm", 'VISUAL_FORM_FAVORITES', 'FavList', getCurrentTimestamp(), parseInt($("#divFormFavList").height(), 10), parseInt($("#divFormFavList").width(), 10), 'true', collid, me.deviceType);
            //adopt the width of the user assigment widget
            $("#divFavUserAssignment").width(me.width - ($("#divFormFavList").width()+70));
            me.vcVisual.addVisualBaseByName("divFav", 'VISUAL_MEMBERSHIP_ASSIGNMENT_FAVORITE2USER', 'UserAssignment', getCurrentTimestamp(), parseInt($("#divFavUserAssignment").height(), 10), parseInt($("#divFavUserAssignment").width(), 10), '', JSON.stringify({'assid': collid}), me.deviceType);


        }
        return true;
    } catch (ex) {
        me.writeError('toggleFavoriteList', ex);
        return false;
    }

};

FavoriteList.prototype.delFavoriteList = function () {
    /// <summary>
    /// This function deletes one favorite list incl all entries.
    /// </summary>
    var me = this;
    try {
        if (me.error) {return false;}

        if (me.visual.find("#ddlList option").length === 1) {
            alert(me.resources.notDeleteSingleFavoriteList);
            return true;
        }
        if (confirm(me.resources.shouldEntryBeDeleted, 'Validation') === false) { return false; }
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, me.day, 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 4, 'collid': me.collid }),
            function (result) {
               
                if (result === 1) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                if (result === 2) {
                    me.visual.find("#divFavDetailNoDel").show();
                    return false;
                }
                me.toggleFavoriteList(false);
                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('delFavoriteList', ex);
        return false;
    }

};

FavoriteList.prototype.initFullscreenDialog = function () {
    /// <summary>
    /// This function inits the modal dialog for fullscreens (almost fullscreen, kind of fullscreen - ok a bit larger as normal)
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        me.dialog = $("<div>").attr("id", "infoDialog").css({ display: "none" });
        me.dialog.dialog({
            autoOpen: false, modal: true, resizable: false, dialogClass: "favoriteDialog", title: '', closeOnEscape: true,
            position: { my: "top-90%", at: "top" },
            buttons: {"Cancel": function () {me.dialog.dialog('close'); return false;}
            }
        });

        // ReSharper disable InvalidValue
        $('.favoriteDialog .ui-button-text:contains(CANCEL)').text(me.resources.close);

        return true;

    } catch (ex) {
        me.writeError('initFullscreenDialog', ex);
        return false;
    }

};

FavoriteList.prototype.goFullscreen = function (obj) {
    /// <summary>
    /// This function opens the fullscreen modal popup and fills it with the selected visual.
    /// </summary>
    var me = this;
    var id;
    try {
        if (me.error) {return false;}

        id = $(obj).attr("data-id");

        me.dialog.html(me.vcC.getLoadingIcon());
        //add the margin and padding of the dialog box to the width
        me.dialog.dialog("option", { "width": me.fullscreenPopupWidth + 54, "height": "auto" }).dialog("open");

        window.VisualCoreService.getData(me.vcvid, me.vcgid, me.day, 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 4, 'collid': me.collid, 'CollEntryId': id, 'Height': me.fullscreenPopupHeight, 'Width': me.fullscreenPopupWidth }),
            function (result) {
                if (result === null || result === "") {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                result = "<div style='background-color:#fff; padding:10px'>" + result + "</div>";
                me.dialog.html(result);
                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('goFullscreen', ex);
        return false;
    }

};

FavoriteList.prototype.showStatus = function (content) {
    /// <summary>
    /// This function shows a status message which fades out after a while. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.find("#status span").show(0).html("<i class='fa fa-check'></i> " + content).delay(1000).fadeOut(1000);
        return true;
    } catch (ex) { writeError('showStatus', ex); return false; }
};

FavoriteList.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#divMenu,#entryList').hide();
            me.visual.find("#divBtnMenu,#divList, #divRightMenu, #divBtnEdit").css("opacity", 0.3);
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};

FavoriteList.prototype.doEvent = function (event) {
    /// <summary>
    /// Handles the closing of the edit vcForm of the favorite list. 
    /// </summary>
    var me = this;
    try {
        switch (event.msg) {
            /// closes the edit vcForm for the favorite list
            case 'FAVORITE_FORM_CLOSED': me.toggleFavoriteList(); break;
            default: break;
        }
    } catch (ex) { writeError('doEvent', ex); }
};



function FavoriteArchive() {
    /// <summary>
    /// This object provides js functions for the Widget.Favorites.Archive.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 12.2.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 21.3.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.day = "";

    this.userOptions = new vcUserOptions();

}

FavoriteArchive.prototype = new vcTemplate();

FavoriteArchive.prototype.init = function() {
    /// <summary>
    /// This function inits the menu click handlers. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showMessage("", false);

        me.visual.width(parseInt(me.width - 35));
        me.visual.height(parseInt(me.height - 50));

        me.visual.find("#divFavChartPrev1").height(parseInt(me.height - 250));
        me.visual.find("#divFavChartPrev1").width(parseInt(me.width - 35));
      

        //divFavChartPrev1
        //init the add button
        //if only one favorite list exists - the button adds the visual
        //if not - the list selection is shown for selecting the prefered list.
        me.visual.find("#divBtnAdd").off('click').on('click', function() {
            if (me.visual.find("#ddlList option").length > 1) {
                me.showListSelection();
            } else {
                me.add();
            }

        });
        //init the save button for the list selection div
        me.visual.find("#divBtnAddList").off('click').on('click', function() {
            me.add();
        });

        //add the name validation
        me.visual.find("#txtName").off('keyup').on('keyup', function() {
            if ($(this).val().length < 1) {
                me.visual.find("#txtName").removeClass("invalid").addClass("invalid");
            } else {
                me.visual.find("#txtName").removeClass("invalid");
            }
        });

        //send a message for receiving the current chart settings
        _VCMQ.produce(me.visual, me.vcgid, 'CHART_SETTINGS', '');

        return true;
    } catch (ex) {
        me.writeError('init', ex);
        return false;
    }

};

FavoriteArchive.prototype.showListSelection = function() {
    /// <summary>
    /// If more than one favorite lists exists the list selection shows up after adding the visual.<br/>
    /// First, an entry in the user options should set the current list.  
    /// </summary>
    var me = this;

    var userFavId;
    try {

        me.userOptions.getUserOptions({ 'optgroupid': 'favorites' }, function(result) {

            if (result !== null) {
                if (result.rows !== null) {

                    for (var i = 0; i < result.rows.length; i++) {
                        //get the stored favorite list
                        if (result.rows[i].optid === FAVORITE_USEROPTION_DEFAULTLIST) {
                            userFavId = parseInt(result.rows[i].dval, 10);
                            if (me.visual.find("#ddlList option[value='" + userFavId + "']").val() !== undefined) {
                                me.visual.find("#ddlList").val(userFavId);
                            }
                        }
                    }
                }
            }
            me.visual.find("#divTips,#divFavWrapper1,#divFavChartPrev1").hide();
            me.visual.find("#divListSelection").show();

            return true;
        });

        return true;
    } catch (ex) {
        me.writeError('showListSelection', ex);
        return false;
    }

};

FavoriteArchive.prototype.show = function() {
    /// <summary>
    /// Sets setting parameters to default values and loads the ramp chart.<br/>
    /// When finished loading (even on error) a message is sent to the ramp menu which activates the cancel button of the dialog box. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.settings.param.UseSimpleBottomLegend = true;
        me.settings.param.UseWidgetHeaderDate = true;
        me.settings.param.separateDataAxis = false;
        me.settings.param.separateMetAxis = false;
        me.settings.param.HideSeries = false;
        me.settings.param.ShowExportIcons = false;
        me.visual.find('#divFavChartPrev1').html(me.vcC.getLoadingIcon());
        me.visual.find("#divBtnAdd").removeClass("active");

      

        me.vcVisual.addVisualContentByName('divFavChart', me.settings.visualname, "Prev1", me.settings.param.endDate, parseInt(me.visual.find("#divFavChartPrev1").height(), 10), parseInt(me.visual.find("#divFavChartPrev1").width(), 10), JSON.stringify(me.settings.param), JSON.stringify(me.settings.signalparam), me.deviceType,
            function() {
                _VCMQ.produce(me.visual, me.vcgid, 'CHART_FAVORITES_LOADED', '');
                me.visual.find("#divBtnAdd").addClass("active");
            }, function() {
                me.visual.find('#divFavChartPrev1').html("<div class='error'>" + me.resources.loadingDataTookTooLong + "</div>");
                _VCMQ.produce(me.visual, me.vcgid, 'CHART_FAVORITES_LOADED', '');
            });


        return true;
    } catch (ex) {
        me.writeError('show', ex);
        return false;
    }

};

FavoriteArchive.prototype.add = function() {
    /// <summary>
    ///  Sends the settings as ajax request to store the given chart in the favorite list.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        if (me.visual.find("#txtName").hasClass("invalid")) {
            alert(me.resources.missingFields);
            return false;
        }

        me.settings.param.loggerID = me.blid;
        var collid = me.visual.find("#ddlList").val();
        var name = me.visual.find("#txtName").val();
        var descr = me.visual.find("#txtDescription").val();

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify({ 'LoggerId': me.blid }), '', 1, 2, JSON.stringify({ 'Collid': collid, 'Visualname': me.settings.visualname, 'Parameter': me.settings.param, 'SignalParameter': me.settings.signalparam, 'Name': name, 'Description': descr }),
            function(result) {
                if (result !== true) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.showMessage(me.resources.chartAdded, false);
                me.visual.find("#divList,#divTips,.seriesTypeMenu,#divFavWrapper1,#divListSelection").hide();
                //send a message to the ramp menu for quitting the dialog box after 1 sec
                setTimeout(function() { _VCMQ.produce(me.visual, me.vcgid, 'CHART_CLOSE_FAVORITES', ''); }, 500);

                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('add', ex);
        return false;
    }

};

FavoriteArchive.prototype.doEvent = function (event) {
    /// <summary>
    /// Handles the mq-events
    /// </summary>
    var me = this;
    try {
        switch (event.msg) {
            /// recieves the current settings of the shown chart from the rampmenu
            case 'CHART_SEND_SETTINGS':
                me.settings = event.values;
                me.show();
                break;
         
            default: break;
        }
    } catch (ex) { writeError('doEvent', ex); }
};

FavoriteArchive.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#divBtnAdd").removeClass("active");
            me.visual.find("#divList,#divTips,.seriesTypeMenu,#divFavWrapper1,#divListSelection").css("opacity", 0.3);
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};

